import { render, staticRenderFns } from "./StartTimerDialog.vue?vue&type=template&id=34911e7a&scoped=true&lang=pug&"
import script from "./StartTimerDialog.vue?vue&type=script&lang=js&"
export * from "./StartTimerDialog.vue?vue&type=script&lang=js&"
import style0 from "./StartTimerDialog.vue?vue&type=style&index=0&id=34911e7a&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34911e7a",
  null
  
)

/* custom blocks */
import block0 from "./StartTimerDialog.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports